import type {CreateExtArgs} from '@wix/document-manager-core'
import {getAccessibilitySettings, setAccessibilitySettings} from './utils'

interface SkipToContentAPI {
    get(): boolean
    set(enabled: boolean): void
}

export const createSkipToContentAPI = (createExtArgs: CreateExtArgs): SkipToContentAPI => {
    const get = (): boolean => {
        const settings = getAccessibilitySettings(createExtArgs)
        return Boolean(settings.skipToContent)
    }

    const set = (enabled: boolean): void => {
        if (enabled !== false && enabled !== true) {
            throw new Error('skipToContent.set accepts only boolean value')
        }

        setAccessibilitySettings(createExtArgs, {
            skipToContent: enabled
        })
    }

    return {
        get,
        set
    }
}
